import React, { useEffect, useState } from 'react';

import { CustomAttributeData } from '../../../customAttributes/customAttributes';
import { PriceData } from '../../../fileFormats/catalog/catalog';

interface ComponentCustomAttributeBooleanProps {
  attribute: CustomAttributeData,
  value: string,
  quantity: number | undefined,
  onValueChanged: (updatedValue: string) => void,
  onQuantityChanged: ((updatedQuantity: number) => void) | undefined,
  editable: boolean,
  priceCurrencySymbol: string,
  priceData: PriceData[] | undefined,
}

export function ComponentCustomAttributeBoolean({
  attribute,
  value,
  quantity,
  onValueChanged,
  onQuantityChanged,
  editable,
  priceCurrencySymbol,
  priceData,
}: ComponentCustomAttributeBooleanProps): JSX.Element {

  const [globalShowPrices, setGlobalShowPrices] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;
    const computedStyle = getComputedStyle(root);

    // Get the value of the CSS variable and interpret it
    const showPricesValue = computedStyle.getPropertyValue('--show-prices').trim();
    setGlobalShowPrices(showPricesValue === 'true');
  }, []);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedQuantity = Math.max(0, parseInt(event.target.value, 10) || 0);
    if (onQuantityChanged !== undefined) {
      onQuantityChanged(updatedQuantity);
    }
  };

  const isNullOption = value !== 'true';
  const basePrice = value === 'false' ? 0 : CustomAttributeData.getAttributeValuePrice(attribute.key, value, attribute.basePrice, priceData);
  const priceTotal = quantity !== undefined ? basePrice * quantity : 0;
  const roundedPriceTotal = Math.round(priceTotal * 100) / 100;
  const priceWithCurrency = `${roundedPriceTotal.toFixed(2)} ${priceCurrencySymbol}`;
  // const priceWithCurrency = `${priceTotal} ${priceCurrencySymbol}`;
  const basePriceWithCurrency = `${basePrice} ${priceCurrencySymbol}`;

  // TODO PMC: Read from Redux Slice "config" the SHOW_PRICE and set accordingly
  const showPrice = globalShowPrices && basePrice > 0;

  return (
    <>
      <div className="col-8">
        <div className="row">
          <div className="col-5">
            <b style={{ color: attribute.color || '#000000' }}>{attribute.name}</b>
          </div>
          <div className="form-check form-switch col-6 justify-content-end">
            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={value === 'true'} onChange={(event) => onValueChanged(event.target.checked ? 'true' : 'false')} />
          </div>
        </div>
      </div>
      <div
        className="col-4"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'right',
        }}
      >
        <div
          className="attribute-value-medium"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
          }}
        >
          {(!isNullOption && showPrice) && (
            <div style={{ marginLeft: '30px' }}>{basePriceWithCurrency}</div>
          )}
          {(!isNullOption && showPrice && attribute.hasQuantity) && (
            <div style={{ marginLeft: '10px' }}> x </div>
          )}
          {(!isNullOption && quantity !== undefined && attribute.hasQuantity) && (
            editable ? (
              <input
                type="number"
                value={quantity}
                min={0}
                step={1}
                onChange={handleQuantityChange}
                style={{
                  marginLeft: '10px', width: '70px', textAlign: 'center',
                }}
              />
            ) : (
              <input
                type="number"
                value={quantity}
                disabled
                style={{ marginLeft: '10px', width: '70px', background: '#e9ecef' }}
              />
            )
          )}
          {(!isNullOption && showPrice && attribute.hasQuantity) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px' }}>=</div>
              <div style={{ marginLeft: '5px', width: '70px', textAlign: 'right' }}>{priceWithCurrency}</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
